// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsMergeParticles_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 8C12 9.10457 11.1046 10 10 10 8.89543 10 8 9.10457 8 8 8 6.89543 8.89543 6 10 6 11.1046 6 12 6.89543 12 8ZM7 9C7 10.1046 6.10457 11 5 11 3.89543 11 3 10.1046 3 9 3 7.89543 3.89543 7 5 7 6.10457 7 7 7.89543 7 9Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9993 8C15.9993 11.3137 13.313 14 9.99933 14C9.05972 14 8.17055 13.784 7.37877 13.399C6.67137 13.7823 5.86111 14 5 14C2.23858 14 0 11.7614 0 9C0 6.23858 2.23858 4 5 4C5.17037 4 5.33874 4.00852 5.50472 4.02516C6.604 2.78307 8.21022 2 9.99933 2C13.313 2 15.9993 4.68629 15.9993 8ZM9.99933 12C9.68233 12 9.37395 11.9631 9.07824 11.8934C8.39798 11.733 7.78487 11.3988 7.28809 10.9404C6.73781 11.5886 5.91694 12 5 12C3.34315 12 2 10.6569 2 9C2 7.34315 3.34315 6 5 6C5.49165 6 5.95568 6.11827 6.36519 6.32791C6.65392 5.70129 7.09993 5.16208 7.65261 4.76086C8.31184 4.28238 9.12245 4 9.99933 4C12.2085 4 13.9993 5.79086 13.9993 8C13.9993 10.2091 12.2085 12 9.99933 12Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsMergeParticles is a generated icon component.
 */
let IconRmsMergeParticles = IconRmsMergeParticles_1 = class IconRmsMergeParticles extends IconBaseElement {
    render() {
        return html `${IconRmsMergeParticles_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsMergeParticles.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconRmsMergeParticles = IconRmsMergeParticles_1 = __decorate([
    customElement('zui-icon-rms-merge-particles')
], IconRmsMergeParticles);
export { IconRmsMergeParticles };
